//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Formboard.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/Expression.js";
import "../no/Routing.js";
let d=[[[0,"BranchAngleType",1,0],[0,"FromPoint",1,"Point",1],[0,"FromVector",1,"Direction",1],[1,"RefRotationAngle",0,"Expression",0],[0,"ReferenceVector",1,"Direction",0],[1,"RotationAngle",0,"Expression",0],[1,"SelectBranch",0,"Routing.RouteObjectCollector",0],[0,"ToPoint",1,"Point",1],[0,"ToVector",1,"Direction",0]],[[["angle"],"UpdateRotationAngle",{},1,1],[[],"StartDrag",{},0,1],[[],"StopDrag",{},0,1],[[],"InitializeFromSegment",{},0,1],[["segmentTag"],"SetBranchSeedObject",{},1,0],[[],"UnSuppressConstraints",{},0,1]],[]];
SPLM.Formboard.OrientBranchBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Formboard.OrientBranchBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Formboard.OrientBranchBuilder.BranchAngleMethod = Object.freeze({
    "AnglefromReferenceVector" : "AnglefromReferenceVector", "Angle" : "Angle", "AlignAxisToVector" : "AlignAxisToVector", "TwoPoints" : "TwoPoints"});

export default SPLM;